var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / SH") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07319C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00247E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,4.66666667 L3.43775544e-17,1.33245595 C1.53913554e-17,0.59656085 0.591622194,0 1.33307666,0 L5.33359001,0 C6.06982792,0 6.66666667,0.587946256 6.66666667,1.33245595 L6.66666667,4.66666667 C6.66666667,8 3.33333333,9.33333333 3.33333333,9.33333333 C3.33333333,9.33333333 0,8 0,4.66666667 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,4.66666667 L3.43775544e-17,1.33245595 C1.53913554e-17,0.59656085 0.591622194,0 1.33307666,0 L5.33359001,0 C6.06982792,0 6.66666667,0.587946256 6.66666667,1.33245595 L6.66666667,4.66666667 C6.66666667,8 3.33333333,9.33333333 3.33333333,9.33333333 C3.33333333,9.33333333 0,8 0,4.66666667 Z",
    id: "path-6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-SH",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-1105",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.333333, 5.333333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-1238",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#8FC5FF",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75653334,6.5502279 C2.75653334,6.5502279 3.42384628,5.68612867 3.81635034,5.68612867 C4.2088544,5.68612867 4.28094963,6.25990043 4.88451008,6.25990043 C5.48807053,6.25990042 5.80638158,5.34547635 6.38774717,5.34547635 C6.96911275,5.34547634 6.38774697,8.34551779 6.38774697,8.34551779 L5.5999552,9.15806909 L0.988616665,9.6906833 L2.75653334,6.5502279 Z",
    id: "Path-61",
    fill: "#366CC9",
    mask: "url(#mask-5)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-61",
    fill: "#CF6200",
    mask: "url(#mask-5)",
    points: "0.79285826 5.2178679 1.38137054 4.66666667 1.95963446 6.08236376 2.7359279 4.66666667 3.40353107 8.70204894 2.29330031 8.47616863 -1.33333333 6.81802231"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFF00",
    mask: "url(#mask-5)",
    x: 0,
    y: 0,
    width: 6.66666667,
    height: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeWidth: 0.666666667,
    d: "M5.33359001,0.333333333 C5.61054974,0.333333333 5.86148388,0.443786359 6.04267348,0.624891597 C6.22269445,0.80482874 6.33333333,1.05422386 6.33333333,1.33245595 L6.33333333,1.33245595 L6.33333333,4.66666667 C6.33333333,7.41140982 3.91524477,8.69921267 3.33396251,8.96908575 C2.97350592,8.80000858 1.89814628,8.23206458 1.13544202,7.16427863 C0.677164597,6.52269023 0.333333333,5.69782042 0.333333333,4.66666667 L0.333333333,4.66666667 L0.333333333,1.33245595 C0.333333333,1.05604555 0.444382524,0.805696778 0.62541511,0.624748484 C0.805827813,0.444419784 1.05556322,0.333333333 1.33307666,0.333333333 L1.33307666,0.333333333 Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12.2968145,-0.578591639 C12.4289261,0.574083174 12.1796848,0.947954902 11.9158002,1.1364439 L11.9158002,1.1364439 L7.66666667,4.1715393 L7.66666667,5.18002169 L15.1566841,11.6000366 L6.57256028,6.33333333 L5.42893208,6.33333333 L-0.333333333,9.93474921 L-0.333333333,8.49512737 L4.33333333,5.16179403 L4.33333333,4.15331164 L-0.901085803,-0.333333333 L0.773488351,-0.333333333 L5.44015502,3 L6.57106792,3 Z",
    id: "Rectangle-36",
    stroke: "#FFFFFF",
    strokeWidth: 0.666666667,
    fill: "#DB1E36",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3.33333333 L0,6 L4.66666667,6 L4.66666667,9.33948135 C4.66666667,9.70427573 4.97256724,10 5.33957926,10 L6.66042074,10 C7.0320601,10 7.33333333,9.69934988 7.33333333,9.33948135 L7.33333333,6 L11.9911963,6 C12.3642483,6 12.6666667,5.69409943 12.6666667,5.3270874 L12.6666667,4.00624593 C12.6666667,3.63460657 12.3646425,3.33333333 11.9911963,3.33333333 L7.33333333,3.33333333 L7.33333333,0 L4.66666667,0 L4.66666667,3.33333333 L0,3.33333333 Z",
    id: "Rectangle-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-36",
    fill: "#DB1E36",
    mask: "url(#mask-2)",
    points: "0 4 5.33333333 4 5.33333333 3.33333333 5.33333333 0 6.66666667 0 6.66666667 3.33333333 6.66666667 4 12 4 12 5.33333333 6.66666667 5.33333333 6.66666667 6 6.66666667 9.33333333 5.33333333 9.33333333 5.33333333 6 5.33333333 5.33333333 0 5.33333333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSh);
export default __webpack_public_path__ + "static/media/SH.48803fd3117c4fdf8811fdc2e91b2bdf.svg";
export { ForwardRef as ReactComponent };